import { Injectable } from '@angular/core';
import { urlServices } from '../../inbound/services/inboundServiceUrls'
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class InboundservicesService {
  constructor(public http: HttpServiceService, public url: urlServices, public ced: encryptionService, public serverURL: ServerURLService) { }

  getViaList() {
    return this.http.get(this.url.getDispatchVia);
  }
  getLoginUserId() {
    return this.http.get(this.url.getLoginUserId);
  }
  getListOfRecpeits(pageId, rows) {
    return this.http.get(this.url.getListOfReceipts + '?page=' + pageId + '&rows=' + rows)
  }
  getAllReceiptCategorie() {
    return this.http.get(this.url.getAllReceiptCategorie)
  }
  getAllReceipetLanguage() {
    return this.http.get(this.url.getAllReceipetLanguage)
  }

  getAllReceiptType() {
    return this.http.get(this.url.getAllReceiptType)
  }
  submitReceiptDetails(file, obj: any) {

    var formdata: FormData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formdata.append('files', file[i]);

    }
    formdata.append('receiptJson', JSON.stringify(obj));
    return this.http.post(this.url.createReceipt, formdata);


  }
  getReceiptDetailsByStatus(id, pageId, rows) {
    return this.http.get(this.url.getAllReceiptByCodes + "?statusCode=" + id + '&page=' + pageId + '&rows=' + rows)
  }
  getReceiptData(receiptId: any) {
    const obj = {
      receiptIdEncr: this.ced.encryptAesToString(receiptId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getReceiptData, obj)
  }

  getReceiptDataForwardedList(receiptId: any) {
    const obj = {
      receiptIdEncr: this.ced.encryptAesToString(receiptId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getReceiptDataForwardedList, obj)
  }

  updateReceipt(file, obj: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formdata.append('files', file[i]);
    }
    formdata.append('receiptJson', JSON.stringify(obj));
    return this.http.updateData(this.url.updateReceiptDatas, formdata)
  }
  forwardReceiptToSeceraty(id, sId, C) {
    return this.http.update(this.url.forwwardReceipt + '?receiptId=' + id + '&secretaryId=' + sId + '&comments=' + C, '')
  }
  // Receipt forward to multiple sectionheads
  forwardReceiptToMultiplesectionheads(obj) {
    return this.http.updateData(this.url.forwwardReceipt, obj);
  }
  getAllUserList() {
    return this.http.get(this.url.getAllUsersList)
  }
  //getAllReceipt by user Id
  getAllReceiptsByUser(userId, pageId, rows) {
    return this.http.get(this.url.getAllReceiptsByUserId + '?userId=' + userId + '&page=' + pageId + '&rows=' + rows)
  }
  //getAllReceipt by user Id
  getAllReceiptsByUserDashboard(userId, pageId, rows) {
    return this.http.get(this.url.getAllReceiptsByUserIdDashboard + '?userId=' + userId + '&page=' + pageId + '&rows=' + rows)
  }
  //assignToSetionExicute
  assignToSetionExicute(data: any) {
    return this.http.update(this.url.assignSectionExecuite, data);
  }
  //assignToAnyDesignation
  assignReceiptToAnyDesignation(obj: any) {
    return this.http.update(this.url.assignReceiptToAnyDesignation, obj);
  }
  //getReceiptCounts
  getReceiptCounts() {
    return this.http.get(this.url.getReceiptCounts + '?userId=' + sessionStorage.getItem('userId-usec') + '&statusName=' + 'Forwarded');

  }
  getReceiptCountss() {
    return this.http.get(this.url.getReceiptCounts + '?userId=' + sessionStorage.getItem('userId-usec') + '&statusName=' + 'Assigned');
  }

  //getReceiptListByUsingDate
  getReceiptListByUsingDate(start, end, page, row) {
    return this.http.get(this.url.getReceiptBwtnDate + '?startDate=' + start + '&endDate=' + end + '&page=' + page + '&rows=' + row);
  }
  //getHistoryByReceiptId
  getHistoryByReceiptId(receiptId) {
    const obj = {
      receiptIdEncr: this.ced.encryptAesToString(receiptId, this.serverURL.secretKey).toString(),
      statusName: 'Assigned'
    }
    return this.http.post(this.url.getHistoryOfReceiptById, obj);
  }
  //assignToSetionIncharge
  assignToSetionIncharge(receiptId, sectionIncharge, comments) {
    return this.http.update(this.url.assignReceiptTosectionIncharge + '?receiptId=' + receiptId + '&sectionIncharge=' + sectionIncharge + '&comments=' + comments, '')
  }
  //reAssignedToSetionIncharge
  reAssignedToSetionIncharge(receiptId, sectionIncharge, comments) {
    return this.http.update(this.url.reassignReceiptTosectionIncharge + '?receiptId=' + receiptId + '&sectionIncharge=' + sectionIncharge + '&comments=' + comments, '')
  }
  //returnReceiptToSecretary
  returnReceiptToSecretary(id, obj: any) {
    return this.http.update(this.url.returnToSecretary + '?receiptId=' + id + '&roleName=' + sessionStorage.getItem('selectedRole-usec'), obj)
  }
  //getUserListByRole
  getUserListByRole(roleName) {
    const roleNameEncr = encodeURIComponent(this.ced.encryptAesToString(roleName, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getUserListByRoleName + '?roleNameEncr=' + roleNameEncr);
  }
  //disposeReceipt
  disposeReceipt(receiptId: any, status: string, value: any) {
    return this.http.update(this.url.disposeReceiptBySecExecutive + '?receiptId=' + receiptId + '&statusName=' + status + '&comments=' + value, '')
  }
  // updateReceipt
  updateReceiptById(receiptId: any, status: string) {
    return this.http.update(this.url.updateReceiptStatusByReceiptId + '?receiptId=' + receiptId + '&statusName=' + status, '')
  }
  //getAllReceipt by user Id
  getAllReceiptsByUserIdAndStatus(userId, status, pageId, rows) {
    return this.http.get(this.url.getAllReceiptsByUserIdAndStatus + '?userId=' + userId + '&statusName=' + status + '&page=' + pageId + '&rows=' + rows)
  }
  // searchReceipt
  searchReceipt(dataa: any, pageId: number, rowId: number) {
    return this.http.get(this.url.seacrhReceiptBySearchInput + '?searchInput=' + dataa + '&page=' + pageId + '&rows=' + rowId)
  }
  // ReceiptVias
  getAllReceiptVias() {
    return this.http.get(this.url.getAllReceiptVias)
  }
  // ReceiptStatuses
  getAllReceiptStatuses() {
    return this.http.get(this.url.getAllReceiptStatuses)
  }
  // ReceiptStatusesInCharge&Executive
  getAllReceiptStatusIn() {
    return this.http.get(this.url.getAllReceiptStatusIn + '?status=' + 'Forwarded' + '&status=' + 'Returned' + '&status=' + 'Assigned' + '&status=' + 'File Tagged' + '&status=' + 'Note Sheet Created' + '&status=' + 'Acknowledgement Sent/Dispatched'  + '&status=' + 'Acknowledgement Sent Via Mail' + '&status=' + 'Acknowledgment Sent For Dispatch'+ '&status=' + 'Acknowledgement Generated' );
  }
  // ReceiptsByUserId
  getAllReceiptsByUserId(userId, page, rowNumber, input) {
    return this.http.post(this.url.getAllReceiptsByUserId + '?userId=' + userId + '&page=' + page + '&rows=' + rowNumber, input)
  }
  // AssignedReceiptsByUserId
  getAllAssignedReceiptsByUserId(userid: any, status, pageid: any, rowid) {
    return this.http.get(this.url.getAllAssignedReceiptsByUserId + '?userId=' + userid
      + '&page=' + pageid + '&rows=' + rowid);
  }
  // SectionHeads
  getAllSectionHeads() {
    return this.http.get(this.url.getAllSectionHeads)
  }
  // assignReceiptToSectionExecutive
  assignReceiptToSectionExecutive(receiptId: number, sectionExecutiveId: number, comments: string) {
    return this.http.get(this.url.assignReceiptToSectionExecutive + '?receiptId=' + receiptId + '&sectionExecutiveId=' + sectionExecutiveId + '&comments=' + comments)
  }
  // AssignedReceiptsByUserIdAndPagination
  getAllAssignedReceiptsByUserIdAndPagination(userid: number, pageid: number, rowid: number, statusName: string) {
    return this.http.get(this.url.getAllAssignedReceiptsByUserIdAndPagination + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid + '&statusName=' + statusName)
  }
  // CountOfReceiptsByStatus
  getCountOfReceiptsByStatus() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getReceiptCounts, obj);

  }
  // CountOfReceiptsByStatus
  getCountOfReceiptsBySectionIncharge() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getCountOfReceiptsBySectionIncharge, obj);

  }
  // CountOfReceiptsByStatus
  getCountOfReceiptsByStatusSectionHead() {
    return this.http.get(this.url.getCountOfReceiptsByStatusSectionHead + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&statusName=' + 'Forwarded');

  }
  getCountOfReceiptsByStatusSecExecutive() {
    return this.http.get(this.url.getReceiptCounts + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&statusName=' + 'Assigned');

  }
  //SecInchargeViewReceipt
  getReceiptDetailsByReceiptId2(receiptId: any) {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      receiptIdEncr: this.ced.encryptAesToString(receiptId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getReceiptDetailsByReceiptId2, obj)
  }

//SecInchargeViewReceipt
getCreateNoteSheetStatus(receiptId: any) {
  const obj = {
    receiptIdEncr: this.ced.encryptAesToString(receiptId, this.serverURL.secretKey).toString(),
    sectionIdEncr: this.ced.encryptAesToString(JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, this.serverURL.secretKey).toString()
  }
  return this.http.post(this.url.getCreateNoteSheetStatus, obj)
}


  // rdviewReceipt
  getReceiptDetailsByReceiptId(receiptId: any) {
    const obj = {
      receiptIdEncr: this.ced.encryptAesToString(receiptId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getReceiptDetailsByReceiptId, obj)
  }

  //Address Category
  get_address_category() {
    return this.http.get(this.url.get_address_category)
  }

  dashBoardSearch(page, rowNumber, input) {
    var formdata: FormData = new FormData();
    formdata.append('receiptJson', JSON.stringify(input));
    return this.http.post(this.url.dashBoardSearch + '?page=' + page + '&rows=' + rowNumber, input)
  }

  dashBoardSearchTrack(page, rowNumber, input) {
    var formdata: FormData = new FormData();
    formdata.append('receiptJson', JSON.stringify(input));
    return this.http.post(this.url.dashBoardSearchTrack + '?page=' + page + '&rows=' + rowNumber, input)
  }

  dashBoardSearchExport( dashBoardSearchDto:any ) {
    return this.http.post(this.url.dashBoardSearchExport,dashBoardSearchDto);
  }

  dashBoardSearchExportReceiptDispatch( receiptDashboardSearchCriteria:any ) {
    return this.http.post(this.url.dashBoardSearchExportReceipt,receiptDashboardSearchCriteria);
  }
  
  dashBoardSearchSection(page, rowNumber, input) {
    var formdata: FormData = new FormData();
    formdata.append('receiptJson', JSON.stringify(input));
    return this.http.post(this.url.dashBoardSearchSection + '?page=' + page + '&rows=' + rowNumber, input)
  }

  dashBoardSearchSectionExport(page, rowNumber, input) {
    var formdata: FormData = new FormData();
    formdata.append('receiptJson', JSON.stringify(input));
    return this.http.post(this.url.dashBoardSearchSectionExport + '?page=' + page + '&rows=' + rowNumber, input)
  }
  
  DashBoardSearchByStatus(page, rowNumber, input) {
    return this.http.post(this.url.DashBoardSearchByStatus + '?page=' + page + '&rows=' + rowNumber, input)
  }
  // getAllDCISections
  getAllDCISections() {
    return this.http.get(this.url.getAllDCISections);
  }
  // getSubSections
  getSubSections(sectionid) {
    const obj = {
      sectionIdEncr: this.ced.encryptAesToString(sectionid, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getSubSections, obj);
  }

  // getAllDesignations
  getAllDesignations() {
    return this.http.get(this.url.getAllDesignations);
  }
  // getUsersByDesignation
  getUsersByDesignation(designationName) {
    return this.http.get(this.url.getUsersByDesignation + '?designation=' + designationName);
  }

  //filterwithstateandname
  getPrinicipalByStateAndName(stateid, principalname,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllPrincipal + '?stateId=' + stateid + '&principalName=' + principalname +'&page='+pageid +'&rows='+rowid);
  }
  getPrinicipalByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllPrincipal + '?stateId=' + stateid+'&page='+pageid +'&rows='+rowid);
  }
  getPrinicipalByName(principalname,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllPrincipal + '?principalName=' + principalname+'&page='+pageid +'&rows='+rowid);
  }


  getUniversityByStateAndName(stateid, principalname,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllUniversity + '?stateId=' + stateid + '&principalName=' + principalname +'&page='+pageid +'&rows='+rowid);
  }
  getUniversityByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllUniversity + '?stateId=' + stateid+'&page='+pageid +'&rows='+rowid);
  }
  getUniversityByName(principalname,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllUniversity + '?principalName=' + principalname+'&page='+pageid +'&rows='+rowid);
  }

  getDMEByStateAndName(stateid, dmename,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllDME + '?stateId=' + stateid + '&dmeName=' + dmename +'&page='+pageid +'&rows='+rowid);
  }
  getDMEByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllDME + '?stateId=' + stateid+'&page='+pageid +'&rows='+rowid);
  }
  getDMEByName(dmename,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllDME + '?dmeName=' + dmename +'&page='+pageid +'&rows='+rowid);
  }
  getHealthSecByStateAndName(stateid, secname,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllHealthSecy + '?stateId=' + stateid + '&secName=' + secname +'&page='+pageid +'&rows='+rowid);
  }
  getHealthSecByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllHealthSecy + '?stateId=' + stateid +'&page='+pageid +'&rows='+rowid);
  }
  getHealthSecByName(secname,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllHealthSecy + '?secName=' + secname +'&page='+pageid +'&rows='+rowid);
  }
  getAdvocateByStateAndName(stateid, advocateName,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllAdvocate + '?stateId=' + stateid + '&advocateName=' + advocateName+'&page='+pageid +'&rows='+rowid);
  }
  getAdvocateByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllAdvocate + '?stateId=' + stateid+'&page='+pageid +'&rows='+rowid);
  }
  getAdvocateByName(advocateName,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllAdvocate + '?advocateName=' + advocateName+'&page='+pageid +'&rows='+rowid);
  }

  getCAByStateAndName(stateid, caName ,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllCounsellingAuthority + '?stateId=' + stateid + '&advocateName=' + caName+'&page='+pageid +'&rows='+rowid);
  }
  getCAByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllCounsellingAuthority + '?stateId=' + stateid+'&page='+pageid +'&rows='+rowid);
  }
  getCAByName(caName,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllCounsellingAuthority + '?caName=' + caName+'&page='+pageid +'&rows='+rowid);
  }

  getSDCByStateAndName(stateid, advocateName,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllSDC + '?stateId=' + stateid + '&secName=' + advocateName+'&page='+pageid +'&rows='+rowid);
  }
  getSDCByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllSDC + '?stateId=' + stateid+'&page='+pageid +'&rows='+rowid);
  }
  getSDCByName(advocateName,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllSDC + '?secName=' + advocateName+'&page='+pageid +'&rows='+rowid);
  }


  getUnivByStateAndName(stateid, principalName,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllUniversity + '?stateId=' + stateid + '&principalName=' + principalName+'&page='+pageid +'&rows='+rowid);
  }
  getUnivByState(stateid,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllUniversity + '?stateId=' + stateid+'&page='+pageid +'&rows='+rowid);
  }
  getUnivByName(principalName,pageid:any,rowid:any) {

    return this.http.get(this.url.getAllUniversity + '?principalName=' + principalName+'&page='+pageid +'&rows='+rowid);
  }


  // getAllprincipal
  getAllPrincipal(pageid:any,rowid:any) {
    return this.http.get(this.url.getAllPrincipal+'?page='+pageid+'&rows='+rowid);
  }
  //getAllUinversity
  getAllUniversity(pageid:any,rowid:any) {
    return this.http.get(this.url.getAllUniversity+'?page='+pageid+'&rows='+rowid);
  }
  // getAllDME
  getAllDME(pageid:any,rowid:any) {
    return this.http.get(this.url.getAllDME+'?page='+pageid+'&rows='+rowid);
  }
  //getAllHealthSec
  getAllHealthSec(pageid:any,rowid:any) {
    return this.http.get(this.url.getAllHealthSecy+'?page='+pageid+'&rows='+rowid);
  }
   //getAllSDC
   getAllSDC(pageid:any,rowid:any) {
    return this.http.get(this.url.getAllSDC+'?page='+pageid+'&rows='+rowid);
  }
  
  // getAllMinistry
  getAllMinistry() {
    return this.http.get(this.url.getAllMinistry);
  }
  // getAllAdvocate
  getAllAdvocate(pageid:any,rowid:any) {
    return this.http.get(this.url.getAllAdvocate+'?page='+pageid+'&rows='+rowid);
  }

   // getAllAdvocate
   getAllCounsellingAuthority(pageid:any,rowid:any) {
    return this.http.get(this.url.getAllCounsellingAuthority+'?page='+pageid+'&rows='+rowid);
  }

  // searchWithFileNum
  searchWithFileNum(fileno, pageid, rowid, sectionId) {
    const obj = {
      page: pageid,
      rows: rowid,
      fileNum: fileno,
      sectionIdEncr: this.ced.encryptAesToString(sectionId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.searchWithFileNum, obj)
  }
  // updateReceiptWithFileNo
  updateReceiptWithFileNo(obj: any) {
    return this.http.update(this.url.updateReceiptWithFileNum, obj);
  }
  // getOtherSectionReceiptsByUserId
  getOtherSectionReceiptsByUserId(userid: any, pageid: any, rowid: any, sectionid: any) {
    return this.http.get(this.url.getOtherSectionReceiptsByUserId + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid +
      '&statusName=' + 'Assigned' + '&sectionId=' + 1)
  }

  //SectionExecutivesBySection
  getSectionExecutivesBySection(sectionName: string) {
    return this.http.get(this.url.getSectionExecutivesBySection + '?sectionName=' + sectionName);
  }

  // Dashboard API
  dispatchedNotesheets(obj: any, pageid: any, rowid: any) {
    if (obj === null) {
      return this.http.get(this.url.dispatchedNotesheets + '?page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.dispatchedNotesheets + '?page=' + pageid + '&rows=' + rowid + obj );
    }
  }

  dashBoardSearchDispatchExport(obj: any, pageid :number, rowid: any) {
    if (obj === null) {
      return this.http.get(this.url.dashBoardSearchDispatchExport + '?page=' + pageid + '&rows=' + rowid);
    } else {
      return this.http.get(this.url.dashBoardSearchDispatchExport + '?page=' + pageid + '&rows=' + rowid + obj);
    }
  }

  dashBoardExportPDF(obj: any) {
    return this.http.post(this.url.dashBoardDispatchExportPDF, obj);
  }

  dakdispatchDashboardExportPDF(obj: any) {
    return this.http.post(this.url.dakdispatchDashboardExportPdf, obj);
  }

 
  updateBarcode(data: any) {
    return this.http.post(this.url.updatedDispatchBarcode, data);
  }

  updateAckdashBarcode(data: any) {
    return this.http.post(this.url.updatedAckDashBarcode, data);
  }

 
  //EmailToPostalDept
  sendEmailtoPostal(userid: any, dispatchNo: any, languageId: any) {
    return this.http.post(this.url.sendEmailtoPostal + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&dispatchNo=' + dispatchNo + '&languageId=' + languageId, '');
  }
  // correctionUsersList
  correctionUsersList() {
    const obj = {
      sectionIdEncr: this.ced.encryptAesToString(JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.correctionUserList, obj);
  }

  printAddress(obj) {
    return this.http.post(this.url.printAddress, obj);
  }

  // getCategoryBySubsection
  getCategoryBySubsection(subsectionId:any){
    return this.http.get(this.url.get_file_category_from_sub_section +'?subSectionId='+subsectionId);
  }
  
  // getSubCategoryByFileCategory
  getSubCategoryByFileCategory(filecategoryId:any){
    return this.http.get(this.url.get_file_sub_category_from_file_category +'?fileCategoryId='+filecategoryId)
  }
// getReferenceBySubCategory
getReferenceBySubCategory(fileSubCategoryId:any){
  return this.http.get(this.url.get_file_subject_reference_from_file_sub_category +'?fileSubCategoryId='+fileSubCategoryId);
}
// getAllCollege
getAllCollege(){
  return this.http.get(this.url.get_all_college);
}
 // getSubCategoryReferenceBySubCategory
 getSubCategoryReferenceBySubCategory(fileSubCategoryId:any){
  return this.http.get(this.url.get_file_sub_category_reference_from_file_sub_category +'?fileSubCategoryId='+fileSubCategoryId);
}
// deletedocument
deleteDocument(documentId:any){
  return this.http.delete(this.url.deleteDocument +'?documentId='+documentId);
}
// getAllFwdReceiptsByUserId
getAllFwdReceiptsByUserId(userid:any,pageid:any,rowid:any){
  return this.http.get(this.url.getAllFwdReceiptsByUserId + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid)
}
// getAllFwdReceiptsByUserId
getAllFwdReceiptsByUserIdDashboard(userid:any,pageid:any,rowid:any){
  return this.http.get(this.url.getAllFwdReceiptsByUserIdDashboard + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid)
}
getAsgReceiptsByUserId(userid: number, pageid: number, rowid: number) {
  return this.http.get(this.url.getAsgReceiptsByUserId + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid)
}

getAsgReceiptsByUserIdDashboard(userid: number, pageid: number, rowid: number) {
  return this.http.get(this.url.getAsgReceiptsByUserIdDashboard + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid)
}

// getotherCategoryusers
getotherCategoryusers(userName:any,phoneNumber:any,pageid:any,rowid:any){
  return this.http.get(this.url.get_other_category_users+'?userName='+userName+'&phoneNumber='+phoneNumber+'&page='+pageid +'&rows=' +rowid);
}
// getAllFwdReceiptById
getAllFwdReceiptById(receiptid){
  const obj = {
    receiptIdEncr: this.ced.encryptAesToString(receiptid, this.serverURL.secretKey).toString(),
  }
  return this.http.post(this.url.getAllFwdReceiptById, obj);
}
// OtherSectionsdispatches
otherSectionDispatches(sectionid:any,pageid:any,rowid:any){
  return this.http.get(this.url.other_section_head_cc+'?sectionId='+sectionid+ '&page=' + pageid + '&rows=' + rowid);
}
// OtherSectionsdispatches
otherSectionCCFiles(pageid:any,rowid:any){
  const obj = {
    roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
    page: pageid,
    rows: rowid
  }
  return this.http.post(this.url.other_section_cc_files, obj);
}
// getCorrectionUsersList
getCorrectionUsersList(dispatchId: any) {
  const obj = {
    dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
  }
  return this.http.post(this.url.getAllCorrectionUsers, obj)

}
// designationListCCFile
designationListCCFile(){
  const obj = {
    sectionIdEncr: this.ced.encryptAesToString(JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, this.serverURL.secretKey).toString()
  }
  return this.http.post(this.url.designationListCCFile, obj)
}
// assignCCFile
assignCCFile(obj:any){
  return this.http.post(this.url.assignCCFile,obj);
}
// tagFileNumToCCFile
tagFileNumToCCFile(obj:any){
  return this.http.post(this.url.tagFileNumToCCFile,obj);
}
// filetaggingToCreateNoteSheet
filetaggingToCreateNoteSheet(ccFileTaggingId:any){
  return this.http.get(this.url.filetaggingToCreateNoteSheet+'?ccFileTaggingId='+ccFileTaggingId);
}
// preview document
previewDocument(uuid:any){
  return this.http.get(this.url.documentUrl+'?uuid='+uuid)
}
// getHistoryUpToSecHeadAssign
getHistoryUpToSecHeadAssign(receiptId:any){
  const obj = {
    receiptIdEncr: this.ced.encryptAesToString(receiptId, this.serverURL.secretKey).toString(),
  }
  return this.http.post(this.url.getHistoryUpToSecHeadAssign, obj);
}
// Seek Clarification To Section Head
seekClarificationToSectionHead(obj) {
  return this.http.update(this.url.seekClarificationToSectionHead, obj);
}

getSectionHeadClarificationList(userid: number, pageid: number, rowid: number) {
  return this.http.get(this.url.getSectionHeadClarificationList + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid)
}

getClarificationListandSearchdWithPagination(obj:any){
  return this.http.post(this.url.getClarificationListandSearchdWithPagination,obj);
}

getSectionExecutiveClarificationListandSearchdWithPagination(obj:any){
  return this.http.post(this.url.getSectionExecutiveClarificationListandSearchdWithPagination,obj);
}

// updateReceiptWithFileNoComment
updateReceiptWithFileNoComments(obj: any) {
  return this.http.update(this.url.updateReceiptWithFileNumComments, obj);
}

// updateReceiptWithFileNoComment
updateClarificationWithFileNoComments(obj: any) {
  return this.http.update(this.url.updateClarificationWithFileNumComments, obj);
}

// updateReceiptWithFileNoComment
updateClarificationWithFileNoCommentsClose(obj: any) {
  return this.http.update(this.url.updateClarificationWithFileNoCommentsClose, obj);
}

//getHistoryByReceiptId
getHistoryOfClarificationId(dispatchId) {
  const obj = {
    dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
  }
  return this.http.post(this.url.getHistoryOfClarificationId, obj);
}

//getHistoryByReceiptId
getAllClarificationCommentsById(dispatchId) {
  const obj = {
    dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
  }
  return this.http.post(this.url.getAllClarificationCommentsById, obj);
}

getSectionExeClarificationList(userid: number, pageid: number, rowid: number) {
  return this.http.get(this.url.getSectionExecutiveClarificationList + '?userId=' + userid + '&page=' + pageid + '&rows=' + rowid)
}

// getHistoryUpToSecHeadAssign
getDispatchIdCountByClarification(dispatchId:any){
  const obj = {
    dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
  }
  return this.http.post(this.url.getDispatchIdCountByClarification, obj);
}

//SecInchargeViewReceipt
getCreateNoteSheetStatusOtherSection(dispatchId: any) {
  const obj = {
    dispatchIdEncr: this.ced.encryptAesToString(dispatchId, this.serverURL.secretKey).toString(),
    sectionIdEncr: this.ced.encryptAesToString(JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, this.serverURL.secretKey).toString()
  }
  return this.http.post(this.url.getCreateNoteSheetStatusOtherSection, obj)
}

getAllRAndDReceiptsByUserIdAndPagination() {
  return this.http.get(this.url.getAllRAndDReceiptsByUserIdAndPagination)
}

//Notification
getReceiptNotificationList(){
  const obj = {
    roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
  }
  return this.http.post(this.url.receiptNotificationList, obj);
}

//Multiple Role
getReceiptListSectionIncharge(receiptDashboardSearchCriteria: any ) {
  return this.http.post(this.url.getReceiptListSectionIncharge,receiptDashboardSearchCriteria);
}

//Multiple Role Track Receipt
getTrackReceiptListSectionIncharge(receiptDashboardSearchCriteria: any ) {
  return this.http.post(this.url.getTrackReceiptListSectionIncharge,receiptDashboardSearchCriteria);
}

//Multiple Role Track Receipt
getAckDashListSectionIncharge(receiptDashboardSearchCriteria: any ) {
  return this.http.post(this.url.getAckDashListSectionIncharge,receiptDashboardSearchCriteria);
}
//R&D section
getReceiptDispatchList(receiptDashboardSearchCriteria: any ) {
  return this.http.post(this.url.getReceiptDispatchList,receiptDashboardSearchCriteria);
}

// getAllFwdReceiptById
previewAcknowledge(receiptid){
  const obj = {
    receiptIdEncr: this.ced.encryptAesToString(receiptid, this.serverURL.secretKey).toString(),
  }
  return this.http.post(this.url.previewAcknowledgeLetter, obj);
}

ackDashboardExportPDF(obj: any) {
  return this.http.post(this.url.ackDashboardExportPDF, obj);
}


// getAllFwdReceiptById
sentAcknowledge(receiptid){
  const obj = {
    receiptIdEncr: this.ced.encryptAesToString(receiptid, this.serverURL.secretKey).toString(),
    roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
  }
  return this.http.post(this.url.sentAcknowledegment, obj);
}

generateAcknowledge(receiptid){
  const obj = {
    receiptIdEncr: this.ced.encryptAesToString(receiptid, this.serverURL.secretKey).toString(),
    roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
  }
  return this.http.post(this.url.generateAcknowledge, obj);
}
getAckReceiptStatusIn() {
  return this.http.get(this.url.getAllReceiptStatusIn +  '?status=' + 'Acknowledgement Sent/Dispatched'  + '&status=' + 'Acknowledgement Sent Via Mail' + '&status=' + 'Acknowledgment Sent For Dispatch' + '&status=' + 'Acknowledgement Generated' );
}

}
